export const presets = [
    {
        name: 'light',
        colors: {
            text: "#282230",
            background: "#f1f1f1",
            bg_2: "#808080",
            contrast_color: "rgba(0, 87, 255, 1)",
            contrast_color_half: "rgba(0, 87, 255, 0.5)",
            contrast_color_2: "rgba(0, 87, 255, 1)",
            contrast_color_3: "#00ffff",
            device_color: "#282828",
            device_button:"#111111",
            icon_invert: "contrast(0)"
        }
    },
    {
        name: 'dark',
        colors: {
            text: "#f1f1f1",
            background: "#272c2f",
            bg_2: "#383d40",
            contrast_color: "rgba(40, 134, 199, 1)",
            contrast_color_half: "rgba(40, 134, 199, 0.7)",
            contrast_color_2: "#27516c",
            contrast_color_3: "#00ffff",
            device_color: "#282828",
            device_button:"#111111",
            icon_invert: "contrast(1)"
        }
    }
]